import React, { useEffect, useMemo, useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { useReactToPrint } from "react-to-print";
import LocalPrintshopOutlinedIcon from "@mui/icons-material/LocalPrintshopOutlined";
import { getFormattedNumber } from "../utils/textUtils";
import { stockTransferByItemReport } from "../../services/Purchase/Reports";

const StockTransferByItem = ({
  resPacket,
  startDate,
  endDate,
  fromWarehouse,
  toWarehouse,
}) => {
  const [show, setShow] = useState(false);
  const [transferList, setTransferList] = useState([]);
  const [selectedItem, setSelectedItem] = useState({});

  useEffect(() => {
    if (!show) {
      setTransferList([]);
      setSelectedItem({});
    }
  }, [show]);

  const getTransfersByItemId = (item) => {
    setSelectedItem(item);
    const request = {
      startDate: startDate,
      endDate: endDate,
      fromWarehouseId: fromWarehouse?.value === "All" ? "" : fromWarehouse?.value || "",
      toWarehouseId: toWarehouse?.value === "All" ? "" : toWarehouse?.value || "",
      itemId: item.itemUuid,
    };
    stockTransferByItemReport(request).then((res) => {
      setTransferList(res.responsePacket?.[0]?.transferList || []);
      setShow(true);
    });
  };

  const componentRef = useRef();
  const handleReactToPrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const handlePrint = () => {
    setTimeout(() => {
      handleReactToPrint();
    }, 1000);
  };

  const total = useMemo(() => {
    return transferList.reduce(
      (acc, cur) => ({
        packQuantity: acc.packQuantity + Number(cur.packQuantity || 0),
        openQuantity: acc.openQuantity + Number(cur.openQuantity || 0),
        amount: acc.amount + Number(cur.amount || 0),
      }),
      { packQuantity: 0, openQuantity: 0, amount: 0 }
    );
  }, [transferList]);

  return (
    <>
      {resPacket && resPacket?.length > 0 ? (
        <div className="customTable" id="scroll">
          <table className="customTable w-100">
            <thead className="fixed-thead">
              <tr>
                <th>SNO.</th>
                <th>ITEM</th>
                <th>ITEM CATEGORY</th>
                <th>
                  ITEM SUB<br></br> CATEGORY
                </th>
                <td className="text-center">PACK QTY.</td>
                <td className="text-center">OPEN QTY.</td>
                <th className="text-center">NO. OF TRANSFERS</th>
                <th className="text-center">TOTAL AMOUNT</th>
              </tr>
            </thead>

            <tbody className="body-scroll-custom">
              {resPacket?.map((a, i) => (
                <tr
                  key={i}
                  onClick={() => getTransfersByItemId(a)}
                  style={{ cursor: "pointer" }}
                >
                  <td>{i + 1}</td>
                  <td className="item-title-blue">
                    {a?.itemTitle} {a?.hsnSac ? `(${a?.hsnSac})` : ""}
                  </td>
                  <td>{a?.category}</td>
                  <td>{a?.subCategory}</td>
                  <td className="text-center">
                    {`${getFormattedNumber(a.packQuantity)} ${a.packUnitTitle || ""}`}
                  </td>
                  <td className="text-center">
                    {`${getFormattedNumber(a.openQuantity)} ${a.openUnitTitle || ""}`}
                  </td>
                  <td className="text-center">{a?.transferCount}</td>
                  <td className="text-center">
                    {Number(a?.totalAmount || 0).toFixed(2)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <>No Record found</>
      )}
      <Modal show={show} onHide={() => setShow(false)} size="xl">
        <div className="d-flex justify-content-between mt-3 mx-4">
          <h3 className="font-size-20">Stock Transfer Report</h3>
          <button className="btn hoverBtn p-1" onClick={handlePrint}>
            <LocalPrintshopOutlinedIcon style={{ fontSize: "22px" }} />
          </button>
        </div>
        <Modal.Body>
          <div
            className="custom-table-div standardTable"
            ref={componentRef}
            id="pdf"
            style={{ width: "100%", margin: "15px", color: "black" }}
          >
            <div className="row p-3 align-items-center">
              <div className="col-5">
                <h2 className="font-size-18 font-weight-bold">
                  {selectedItem.itemTitle}{" "}
                  {selectedItem.hsnSac && ` (${selectedItem.hsnSac})`}
                </h2>
              </div>
              <div className="col-7">
                <div className="d-flex justify-content-end align-items-center">
                  <span className="mr-5">Start Date: {startDate}</span>
                  <span>End Date: {endDate}</span>
                </div>
              </div>
            </div>
            <hr style={{ backgroundColor: "#ececec" }} />
            <div>
              {transferList?.length > 0 ? (
                <div>
                  <table className="table">
                    <thead>
                      <tr>
                        <th>SNO.</th>
                        <th>STN No.</th>
                        <th>Transfer Date</th>
                        <th>From Warehouse</th>
                        <th>To Warehouse</th>
                        <th>Pack Qty</th>
                        <th>Open Qty</th>
                        <th>Rate</th>
                        <th>Amount</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {transferList.map((a, i) => (
                        <tr key={i}>
                          <td>{i + 1}</td>
                          <td>{a.stockTransferNo}</td>
                          <td>{a.stockTransferDate}</td>
                          <td>{a.fromWarehouseTitle}</td>
                          <td>{a.toWarehouseTitle}</td>
                          <td>
                            {Number(a.packQuantity)?.toFixed(2)}
                            &nbsp;{a.packUnitTitle}
                          </td>
                          <td>
                            {Number(a.openQuantity)?.toFixed(2)}
                            &nbsp;{a.openUnitTitle}
                          </td>
                          <td>{Number(a.rate)?.toFixed(2)}</td>
                          <td>{Number(a.amount)?.toFixed(2)}</td>
                          <td>{a.status}</td>
                        </tr>
                      ))}
                      <tr>
                        <td colSpan={5}>
                          <b>Total</b>
                        </td>
                        <td>
                          <b>{total.packQuantity.toFixed(2)}</b>
                        </td>
                        <td>
                          <b>{total.openQuantity.toFixed(2)}</b>
                        </td>
                        <td></td>
                        <td>
                          <b>{total.amount.toFixed(2)}</b>
                        </td>
                        <td></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ) : (
                <>No Record found</>
              )}
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default StockTransferByItem;
